import clsx from 'clsx';
import { useTranslation } from 'react-i18next';
import { Flame, ChevronRight } from 'lucide-react';
import styles from './StatisticNew.module.scss';

const PremiumFeatureLock = ({ children, onUpgrade, className, compact = false }) => {
  const { t } = useTranslation();

  return (
    <div className={clsx(styles.premiumLock, compact && styles.premiumLockCompact, className)}>
      <div className={styles.premiumLockMock} aria-hidden="true">
        {children}
      </div>
      <div className={styles.premiumLockOverlay}>
        <div className={styles.premiumLockCard}>
          <div className={styles.premiumLockHead}>
            <span className={styles.premiumLockIcon} aria-hidden="true">
              <Flame size={compact ? 14 : 16} strokeWidth={2.4} fill="currentColor" />
            </span>
            <h3 className={styles.premiumLockTitle}>{t('statistics.premiumLock.title')}</h3>
          </div>
          <button type="button" className={styles.premiumLockCta} onClick={onUpgrade}>
            <span>{t('statistics.premiumLock.cta')}</span>
            <ChevronRight size={16} strokeWidth={2.5} aria-hidden="true" />
          </button>
        </div>
      </div>
    </div>
  );
};

export default PremiumFeatureLock;
